// check
function checkIfContentInSection() {
    let awardsSection, testimonialsSection, newsSection;

    awardsSection =         document.getElementById('accolades-awards');
    testimonialsSection =   document.getElementById('testimonials');
    newsSection =           document.getElementById('whats-happening');

    // check awards has content
    // easy way: if there's an image tag present, you're good!
    if (awardsSection.querySelector('img') == null) {
        awardsSection.classList.add('d-none');
    }
    
    // check testimonials has content
    let testimonialExists = Array.from(
        document.querySelectorAll('.universal-grid-text-item')
    ).some(box => box.innerText.trim().length > 0);
    if (!testimonialExists) {
        testimonialsSection.classList.add('d-none');
    }

    // check news has content
    if (newsSection.querySelector('img') == null) {
        newsSection.classList.add('d-none');
    }
}

document.addEventListener("DOMContentLoaded", (event) => { checkIfContentInSection(); });
